//import { formatMs } from '@material-ui/core';
import React from "react";
import { Link } from "react-router-dom";
import ItemIcon from "./ItemIcon";
import ItemWishlistIcon from "./ItemWishlistIcon";

const Item = (props) => {
  let category = props.item.category.find((el) => el.livello && el.livello === "2");
  if (!category) {
    category = {
      slug: "burago",
      id_category_list: "5",
    }
  }
  let urlItem =
    "/"+props.catalogSlug+"/" +
    category.slug +
    "/" +
    props.item.slug +
    "/" +
    props.item.id_e_products;
  let urlImg;
  if (props.item.images.length > 0) urlImg = props.item.images[0].url;
  else urlImg = "/images/img_not_available.jpg";

  const categoryCssClass = [
    "",
    "",
    "",
    "ferrari",
    "bburago",
    "junior",
    "maisto",
    "maisto-tech",
    "polistil-el",
    "polistil-ba",
  ];
  let css = "";
  if (category && category.id_category_list <= categoryCssClass.length)
    css = categoryCssClass[category.id_category_list - 1];

  function handleClick(ev) {
    if (props.navClick) {
      props.navClick(ev);
    }
  }
  /*
  function convert(num) {
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  */

  let preferito = false;
  if (props.wishlist && typeof(props.wishlist.id_e_produtcs_list) !== 'undefined') {
    preferito =  (props.wishlist.id_e_produtcs_list.indexOf(props.item.id_e_products) > -1 )
  }
  
  //console.log(props.item);
  return (
    <div className="torre_articolo">
      <div className={"torre_articolo_categoria " + css}>&nbsp;</div>
      <Link to={urlItem} onClick={(ev) => handleClick(ev)}>
        <div className="torre_articolo_img_01">
          <img src={urlImg} alt={props.item.nome} />
          <div className="torre_articolo_note">
            {!props.item || !props.item.label
              ? null
              : props.item.label.map((el, i) => (
                  <ItemIcon
                    key={"itlb_" + props.item.id_e_products + "_" + i}
                    cssClass={"torre_articolo_nota" + el.code}
                    text={el.value}
                    fg={true}
                  />
                ))}
          </div>
          {props.item.sconto_calcolato > 0 ? (
            <div className="ico-torre_sconto">
              <p>-{props.convert(props.item.sconto_calcolato)}%</p>
            </div>
          ) : null}
        </div>
      </Link>
      <ItemWishlistIcon
        on={preferito}
        id={props.item.id_e_products}
        toggle={props.toggle}
      />
      <Link to={urlItem}>
        <div className="torre_articolo_titolo">
          <p className="torre_articolo_scala">{props.item.nome_scala}</p>
          <h2>{props.item.nome + " - " + props.item.codice}</h2>
        </div>
      </Link>
      <h3>
        <span className="prezzo">
          &euro; {props.convert(props.item.prezzo_b2c)}
        </span>
        {props.item.prezzo_b2c !== props.item.prezzo_listino ? (
          <span className="barrato">
            &euro; {props.convert(props.item.prezzo_listino)}
          </span>
        ) : null}
      </h3>
      {props.item.vendibile === "1" ? (
        <div
          className="torre_articolo_carrello"
          onClick={() => props.click(props.item.id_e_products)}
        >
          <p>Aggiungi al carrello</p>
        </div>
      ) : (
        <div className="torre_articolo_non_disponibile">
          <p>Non disponibile</p>
        </div>
      )}
      <div className="stacco_inferiore">&nbsp;</div>
    </div>
  );
};

export default Item;
